import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { closeAiTermsOfUseBanner, initTutorState, setDisplayMode, setNudgesEnabled, setTutorSessionId } from 'src/app/reducers/room/tutor.reducer';
import { useGetUserQuery } from 'src/common/slices';
export const useTutorSessionInit = (roomCode: string) => {
  const dispatch = useAppDispatch();
  const {
    data
  } = useGetUserQuery();
  const {
    stateInit
  } = useAppSelector(state => state.tutor);
  const userData = data?.data?.user;

  // biome-ignore lint/correctness/useExhaustiveDependencies: stateInit is intentionally omitted to prevent re-initialization
  useEffect(() => {
    if (stateInit || !userData) {
      return;
    }
    const {
      sessions,
      displayMode,
      hasSeenAiTermsOfUseBanner
    } = userData?.settings?.tutor ?? {};
    if (sessions) {
      const lastSession = sessions[roomCode];
      const lastSessionId = lastSession?.sessionId;
      if (lastSessionId) dispatch(setTutorSessionId(lastSessionId));
    }
    if (displayMode) dispatch(setDisplayMode(displayMode));
    const nudgesEnabled = sessions?.[roomCode]?.nudgesEnabled;
    if (nudgesEnabled !== undefined) dispatch(setNudgesEnabled(nudgesEnabled));
    if (hasSeenAiTermsOfUseBanner) dispatch(closeAiTermsOfUseBanner());
    dispatch(initTutorState());
  }, [userData, dispatch, roomCode]);
};